import { keyBy, omit } from "lodash";

import { CRUDAction, RequestAction } from "../actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "../reducer";

import { RuleAction, RulesActionsNames } from "./actions";
import {
  IRule,
  IRuleDeleteSuccessPayload,
  IRuleFetchCollectionSuccessPayload,
  IRuleFetchSuccessPayload,
  IRuleSyncDeletePayload,
  IRuleUpdateCountersPayload,
  IRuleUpdateSuccessPayload,
} from "./interfaces";

const initialState = {};

export const rulesReducer = (
  state: IEntityCollectionState<IRule> = initialState,
  action: RuleAction
): IEntityCollectionState<IRule> => {
  switch (action.type) {
    case RulesActionsNames[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]:
    case RulesActionsNames[CRUDAction.CREATE][RequestAction.SUCCESS]: {
      const { id, value: rule } = action.payload as IRuleFetchSuccessPayload;
      return {
        ...state,
        [id]: rule,
      };
    }

    case RulesActionsNames[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values } = action.payload as IRuleFetchCollectionSuccessPayload;
      return keyBy(values, v => v.id);
    }

    case RulesActionsNames[CRUDAction.UPDATE][RequestAction.SUCCESS]: {
      const { id, value } = action.payload as IRuleUpdateSuccessPayload;
      return {
        ...state,
        [id]: { ...state[id], ...value },
      };
    }

    case RulesActionsNames[CRUDAction.DELETE][RequestAction.SUCCESS]: {
      const { id } = action.payload as IRuleDeleteSuccessPayload;

      // @ts-expect-error TS(2769): No overload matches this call.
      const newState = omit(state, id);
      return newState;
    }

    case RulesActionsNames.SYNC_DELETE: {
      const { id } = action.payload as IRuleSyncDeletePayload;

      const newState = omit(state, id);
      return newState;
    }

    case RulesActionsNames.UPDATE_COUNTERS: {
      const counterUpdates = action.payload as IRuleUpdateCountersPayload;

      const newState = counterUpdates.reduce((prevState, counterUpdate) => {
        const rule = state[counterUpdate.ID];
        if (rule) {
          return { ...prevState, [rule.id]: { ...rule, useCounter: counterUpdate.useCounter } };
        }
        return prevState;
      }, state);

      return newState;
    }

    default:
      return state;
  }
};
